import {ReceiptExpensesType, SiteTargetType} from "@/enums/type";
import {DebtEmployeeStatus, DebtPostOfficeStatus} from "@/enums/status";

export class ReceiptPostOfficeParams {
    page = 1;
    limit = 10;
    postOfficeRowGuid?: string;
    type = ReceiptExpensesType.PickingListCollect;
    status = DebtPostOfficeStatus.NotYetCollect;
    revenueExpenditureId?: number;
}
